import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
import { classInstance } from '@/shared/helpers/helpers';

export class MainUspSlider {
	private readonly element: HTMLElement;
	private sliderElement!: HTMLElement;
	private buttonPrev!: HTMLElement;
	private buttonNext!: HTMLElement;
	private paginationElement!: HTMLElement;
	private slider!: Swiper;
	private sliderSettings = (): SwiperOptions => ({
		modules: [Navigation, Pagination],
		slidesPerView: 3,
		spaceBetween: 1,
		breakpoints: {
			500: {
				slidesPerView: 4,
				allowTouchMove: false
			},
			1000: {
				slidesPerView: 4
			},
			1600: {
				slidesPerView: 4,
				spaceBetween: 20
			},
		},
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		pagination: {
			el: this.paginationElement,
			type: 'progressbar',
		},
	});

	constructor(element) {
		if (!element || window.app.classInstance.get(element)) return;
		this.element = element;

		this.init();
	}

	public init(): void {
		this.sliderElement = this.element.querySelector('.main-usp__swiper') as HTMLElement;
		this.buttonPrev = this.element.querySelector('.slider-navigation__button--prev') as HTMLElement;
		this.buttonNext = this.element.querySelector('.slider-navigation__button--next') as HTMLElement;
		this.paginationElement = this.element.querySelector('.slider-navigation__pagination') as HTMLElement;
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		classInstance.set(this.element, this);
	}

	public destroy(): void {
		classInstance.del(this, 'MainUspSlider');
		this.slider?.destroy();
		this.sliderElement = null;
		this.buttonPrev = null;
		this.buttonNext = null;
		this.paginationElement = null;
		this.slider = null;
	}
}
